export default from './header-avatar-image';



// WEBPACK FOOTER //
// ./app/components/header-avatar-image/index.js